// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navfont500{font-size:13px!important}.navfont{font-size:14px!important}.navhome{font-size:18px!important;font-weight:700;color:#f4d03f}", ""]);
// Exports
module.exports = exports;
